"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _indexModule = _interopRequireDefault(require("./index.module.scss")); // Container
// =========


var Container = function Container(_ref) {
  var _ref$centred = _ref.centred,
      centred = _ref$centred === void 0 ? false : _ref$centred,
      type = _ref.type,
      children = _ref.children,
      className = _ref.className,
      _ref$spaced = _ref.spaced,
      spaced = _ref$spaced === void 0 ? false : _ref$spaced;
  var classNames = (0, _classnames.default)(type && _indexModule.default[type], centred && _indexModule.default.container, spaced && _indexModule.default.containerSpaced, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classNames
  }, children);
};

Container.propTypes = {
  centred: _propTypes.default.bool,
  type: _propTypes.default.oneOf(['full', 'large', 'medium', 'small']),
  spaced: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = Container;
exports.default = _default;